export default "__VITE_ASSET__WaMkXxfV__"